import React, { useEffect, useState } from "react";
import { useRef } from "react";

function useScroll() {
  const MOBILE_SCROLL_ERR_OFFSET = 2; // 실 모바일 브라우저 환경에서 발생하는 스크롤 이슈 보완용 오차 범위
  const pageSection = useRef(null);
  const [isScrollBottom, setScrollBottom] = useState(false);

  const onScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget; // same as pageSection
    const isAtBottom =
      scrollHeight - MOBILE_SCROLL_ERR_OFFSET <= clientHeight + scrollTop;
    setScrollBottom(isAtBottom);
  };

  useEffect(() => {
    pageSection.current = document.getElementById("page_section");
  }, []);

  useEffect(() => {
    // window, document : 리스트 앱화면이 아닌 백그라운드를 포함한 전체 페이지로 계산하는 이슈
    if (!pageSection.current) return;
    pageSection.current.addEventListener("scroll", onScroll);
    return () => {
      pageSection.current.removeEventListener("scroll", onScroll);
    };
  }, []);

  return isScrollBottom;
}

export default useScroll;
